export default "__VITE_ASSET__Ckex5HHY__"